<template>
    <div class="">
      <el-row style="margin-top: 10px">
        <el-col>
          <el-card>
            <div slot="header">
              Shadowrocket二维码
            </div>
            <el-row>
              <el-col :span="24">
                <el-form :model="form" label-width="100px" label-position="right" style="width: 100%" v-loading="loading">
                  <el-form-item label="订阅名:">
                    <el-input v-model="form.fileName"
                              clearable
                              @blur="saveFileName"
                              placeholder="请输入订阅名"/>
                  </el-form-item>
                  <el-form-item label="订阅链接:">
                    <el-input v-model="form.sourceSubUrl" type="textarea" rows="4"
                              clearable
                              @blur="saveSubUrl"
                              placeholder="请输入完整的订阅链接URL"/>
                  </el-form-item>

                  <el-form-item>
                    <div style="display: flex; justify-content: center;">
                      <el-button style="width: 150px" type="primary" @click="renderQRCode"
                                 icon="el-icon-picture-outline-round"
                                 :disabled="form.sourceSubUrl.length === 0">生成小火箭二维码
                      </el-button>

                      <el-button @click="resetForm"
                                 icon="el-icon-delete">清除内容
                      </el-button>
                    </div>
                  </el-form-item>

                  <el-form-item label="二维码:" v-if="qrCodeSrc">
                    <div style="display: flex;justify-content: flex-start">
                      <el-card class="box-card" :body-style="{ padding: '0' }" shadow="always">
                        <vue-qr v-if="qrCodeSrc" style="width:260px;height:260px;" :text="qrCodeSrc" :size="260"></vue-qr>
                      </el-card>
                    </div>
                  </el-form-item>

                  <el-form-item label="二维码内容:" v-if="qrCodeSrc">
                      <div style="word-break: break-all;">
                        {{qrCodeSrc}}
                      </div>
                  </el-form-item>


                </el-form>
              </el-col>
            </el-row>

          </el-card>
        </el-col>
      </el-row>


    </div>
</template>
<script>
import VueQr from 'vue-qr'

export default {
  name: "ShadowrocketQRCode",
  components: {VueQr},
  props: {
  },
  data() {
    return {
      loading: false,
      // 是否为 PC 端
      isPC: true,

      form: {
        sourceSubUrl: "",
        fileName: "",
      },

      qrCodeSrc: undefined,
    };
  },
  watch: {},
  mounted() {
    // 获取 url cache
    if (process.env.VUE_APP_USE_STORAGE === 'true') {
      this.form.sourceSubUrl = this.getLocalStorageItem('ShadowrocketQRCode_sourceSubUrl')
    }

    if (process.env.VUE_APP_USE_STORAGE === 'true') {
      this.form.fileName = this.getLocalStorageItem('ShadowrocketQRCode_fileName')
    }
  },
  computed: {},
  methods: {

    renderQRCode() {

      if(!this.form.sourceSubUrl){
        return
      }

      // if (!this.form.sourceSubUrl.startsWith("http")) {
      //   this.$notify.error({
      //     title: '提示',
      //     message: '订阅链接必须以http或https开头'
      //   });
      //   return
      // }

      let qrCodeSrc = this.form.sourceSubUrl;
      qrCodeSrc = `sub://${btoa(qrCodeSrc)}`
      if (this.form.fileName) {
        qrCodeSrc = `${qrCodeSrc}#${encodeURIComponent(this.form.fileName)}`
      }

      //console.log('Shadowrocket二维码路径: ' + qrCodeSrc)
      this.qrCodeSrc = qrCodeSrc
    },


    resetForm(){
      this.form.fileName = "";
      this.form.sourceSubUrl = "";
      this.qrCodeSrc = "";

    },

    saveFileName() {
      if (this.form.sourceSubUrl !== '') {
        this.setLocalStorageItem('ShadowrocketQRCode_fileName', this.form.fileName)
      }
    },

    saveSubUrl() {
      if (this.form.sourceSubUrl !== '') {
        this.setLocalStorageItem('ShadowrocketQRCode_sourceSubUrl', this.form.sourceSubUrl)
      }
    },
    getLocalStorageItem(itemKey) {
      const now = +new Date()
      let ls = localStorage.getItem(itemKey)

      let itemValue = ''
      if (ls !== null) {
        let data = JSON.parse(ls)
        if (data.expire > now) {
          itemValue = data.value
        } else {
          localStorage.removeItem(itemKey)
        }
      }

      return itemValue
    },
    setLocalStorageItem(itemKey, itemValue) {
      const ttl = process.env.VUE_APP_CACHE_TTL
      const now = +new Date()

      let data = {
        setTime: now,
        ttl: parseInt(ttl),
        expire: now + ttl * 1000,
        value: itemValue
      }
      localStorage.setItem(itemKey, JSON.stringify(data))
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
